function parseFiniteNumber(value) {
  if ((typeof value !== "string" && typeof value !== "number") || String(value).trim() === "") {
    return null;
  }

  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) ? parsedValue : null;
}

!(function () {
  "use strict";
  customElements.get("quantity-counter") ||
    customElements.define(
      "quantity-counter",
      class extends HTMLElement {
        constructor() {
          super();
          this.btn_name = null;
        }
        connectedCallback() {
          (this.input = this.querySelector("input")),
            (this.changeEvent = new Event("change", { bubbles: !0 })),
            (this.buttonClickEvent = this.onButtonClick.bind(this)),
            (this.onQuantityChangeEvent = this.onQuantityChange.bind(this)),
            (this.onQuantityBlurEvent = this.onQuantityBlur.bind(this)),
            this.input.addEventListener("change", this.onQuantityChangeEvent),
            this.input.addEventListener("blur", this.onQuantityBlurEvent),
            this.querySelectorAll("button").forEach((t) => t.addEventListener("click", this.buttonClickEvent));

          if (this.input.dataset.customProduct === "true") {
            this.normalizeCustomQuantity();
          }
          calcBaseFeaturePrice(this.input.value, this.input.dataset.key);
        }
        normalizeCustomQuantity(value = this.input.value) {
          const min_value = parseFiniteNumber(this.input.min) ?? 0;
          const quantity = Math.max(parseFiniteNumber(value) ?? min_value, min_value);
          const formatted_quantity = quantity.toFixed(2);
          this.input.value = formatted_quantity;
          this.input.setAttribute("data-propertie-mts", formatted_quantity);
          return quantity;
        }
        updateStockNotice() {
          if (this.input.name !== "properties[Metros]") return;

          const form = this.input.closest("form");
          const stockButton = form?.querySelector(".wim-prev-add-to-cart");
          const stockError = form?.querySelector(".product__submit__item--error-message-stock-mts");
          const exceedsStock = this.input.dataset.policy === "false"
            && parseFloat(this.input.value) > parseFloat(this.input.dataset.stockMts);

          stockButton?.classList.toggle("d-none", !exceedsStock);
          if (!exceedsStock) {
            stockError?.classList.add("d-none");
          }
        }
        onButtonClick(t) {
          t.preventDefault();
          const e = this.input.value,
            n = "BUTTON" == t.target.nodeName ? t.target : t.target.closest("button");
          if (n.name === "increase") {
            this.btn_name = "increase";
            let max_value = isNaN(parseFloat(this.input.max)) || parseFloat(this.input.max) === 0 ? 999999 : parseFloat(this.input.max);
            if (this.input.dataset.esTela && this.input.dataset.esTela === "true") {
              const min_value = parseFiniteNumber(this.input.min) ?? 0;
              const current_mts = parseFiniteNumber(this.input.dataset.propertieTelaMts) ?? parseFiniteNumber(this.input.value) ?? min_value;

              const base_mts = Math.max(current_mts, min_value);
              const next_mts = Math.round((base_mts + 0.5) * 100) / 100;
              const new_mts = Number.isFinite(next_mts) ? next_mts : min_value;
              const formatted_mts = new_mts.toFixed(2);

              this.input.setAttribute("data-propertie-tela-mts", formatted_mts);
              this.input.value = formatted_mts;
              this.updateStockNotice();
            }
            else if (this.input.dataset.customProduct && this.input.dataset.customProduct === "true") {

              const new_mts = this.normalizeCustomQuantity() + 0.5;
              this.normalizeCustomQuantity(Math.min(new_mts, max_value));
            }
            if (this.input.name != "properties[Metros]" && this.input.dataset.customProduct != "true" && this.input.dataset.esTela != "true") {
              this.input.stepUp();
            }
          }
          if (n.name === "decrease") {
            let min_value = isNaN(parseFloat(this.input.min)) ? 0 : parseFloat(this.input.min);
            this.btn_name = "decrease";
            if (this.input.dataset.esTela && this.input.dataset.esTela === "true") {
              const valid_min_value = parseFiniteNumber(this.input.min) ?? 0;
              const current_mts = parseFiniteNumber(this.input.dataset.propertieTelaMts) ?? parseFiniteNumber(this.input.value) ?? valid_min_value;

              const base_mts = Math.max(current_mts, valid_min_value);
              const next_mts = Math.max(valid_min_value, Math.round((base_mts - 0.5) * 100) / 100);
              const new_mts = Number.isFinite(next_mts) ? next_mts : valid_min_value;
              const formatted_mts = new_mts.toFixed(2);

              this.input.setAttribute("data-propertie-tela-mts", formatted_mts);
              this.input.value = formatted_mts;
              this.updateStockNotice();
            }
            else if (this.input.dataset.customProduct && this.input.dataset.customProduct === "true") {

              this.normalizeCustomQuantity(this.normalizeCustomQuantity() - 0.5);
            }
            if (this.input.name != "properties[Metros]" && this.input.dataset.customProduct != "true" && this.input.dataset.esTela != "true") {
              this.input.stepDown();
            }
          }
          if (e !== this.input.value) this.input.dispatchEvent(this.changeEvent);
        }
        onQuantityChange() {
          if (this.input.dataset.esTela && this.input.dataset.esTela === "true") {

            if (parseFloat(this.input.value) != this.input.dataset.propertieTelaMts && parseFloat(this.input.value) > parseFloat(this.input.min)) {

              this.input.setAttribute("data-propertie-tela-mts", parseFloat(this.input.value).toFixed(2));
            }
            if (this.input.name === "properties[Metros]") {
              let value = parseFloat(this.input.value);
              let min_value = isNaN(parseFloat(this.input.min)) ? 0 : parseFloat(this.input.min);
              if (isNaN(value) || value < min_value) {
                this.input.value = min_value.toFixed(2);
              } else if (value >= min_value) {
                this.input.value = ((value * 100).toFixed(2) / 100).toFixed(2);
              }
              this.updateStockNotice();
              this.input.setAttribute("data-propertie-tela-mts", parseFloat(this.input.value).toFixed(2));
              this.querySelector("input[name='quantity']").value = 1;
            }
          }
          else if (this.input.dataset.customProduct && this.input.dataset.customProduct === "true") {

            this.normalizeCustomQuantity();
            if (this.input.dataset.type === 'base') {
              calcBaseFeaturePrice(this.input.value, this.input.dataset.key);
            }
          }
          if (["updates[]", "cartLine[mts]"].includes(this.input.name)) {
            if (!isNaN(parseFloat(this.input.value))) {
              this.updateCart();
            }
          }
        }
        onQuantityBlur() {
          if (this.input.dataset.esTela && this.input.dataset.esTela === "true") {
            let value = parseFloat(this.input.value);
            let min_value = isNaN(parseFloat(this.input.min)) ? 0 : parseFloat(this.input.min);
            if (isNaN(value) || value < min_value) {
              this.input.value = min_value.toFixed(2);
            }
            else {
              this.input.value = ((parseFloat(this.input.value) * 100).toFixed(2) / 100).toFixed(2);
              this.updateStockNotice();
            }
            if (this.input.name === "properties[Metros]") {
              this.querySelector("input[name='quantity']").value = 1;
            }
            if (parseFloat(this.input.value) != value && !isNaN(parseFloat(this.input.value))) {
              this.input.setAttribute("data-propertie-tela-mts", parseFloat(this.input.value).toFixed(2));
              this.updateCart();
            }
          }
          else if (this.input.dataset.customProduct && this.input.dataset.customProduct === "true") {

            this.normalizeCustomQuantity();
            if (this.input.dataset.type === 'base') {
              calcBaseFeaturePrice(this.input.value, this.input.dataset.key);
            }
          }
        }
        updateCart() {
          if ("" !== this.quantityValue) {
            this.dispatchEvent(new CustomEvent("theme:cart:update", {
              bubbles: !0,
              detail: {
                properties: {
                  Metros: this.input.dataset.propertieTelaMts,
                  stock_mts: this.input.dataset.stockMts,
                  inv: this.input.dataset.policy
                },
                button: this.btn_name,
                id: this.input.dataset.id,
                quantity: this.input.dataset.esTela && this.input.dataset.esTela === "true" ? 1 : this.input.value
              }
            }))
          };
        }
      }
    );
})();

function calcBaseFeaturePrice(input_value, feature_key) {
  let data_calculate_scale_price = document.querySelector(`input[name='calculate_scale_${feature_key}']`);
  if (data_calculate_scale_price) {
    let calculate_scale_type = data_calculate_scale_price.dataset.calculate;
    let price_base = parseFloat(document.querySelector('[data-custom-product-price]').dataset.customProductPrice) / 100;
    let add_price = 0;
    if (calculate_scale_type === 'single-price-scale') {
      let single_scale = window.custom_product.base[feature_key.replace('base_feature_', '')]?.value || null;
      const min_quantity = parseFiniteNumber(single_scale.minQty) ?? 0;
      const quantity = parseFiniteNumber(input_value) ?? min_quantity;
      const scale = parseFiniteNumber(single_scale.scale);
      if (scale === null) {
        console.error('Cannot calculate base feature price because scale is not a finite number.', single_scale.scale);
        return;
      }
      let num_aplay_scale = 0;
      if (scale !== 0) {
        num_aplay_scale = quantity > min_quantity ? 1 : 0;
        num_aplay_scale += (quantity - min_quantity) / scale;
      }

      if (single_scale.type === 'percentage') {
        let total_percentage = (num_aplay_scale * single_scale.value) / 100;
        add_price = price_base * total_percentage;
      }
      else {
        add_price = (num_aplay_scale * single_scale.value);
      }
    }
    else if (calculate_scale_type === 'table-price') {

      let table_item = (window.custom_product.base[feature_key.replace('base_feature_', '')]?.value?.items || []).reduce((previous_item, current_item) => {
        previous_item = parseFloat(input_value) >= current_item.minQty ? current_item : previous_item;
        return previous_item;
      }, null);
      if (table_item) {
        if (table_item.type === 'percentage') {
          add_price = price_base * (table_item.value / 100);
        }
        else {
          add_price = table_item.value;
        }
      }
    }
    data_calculate_scale_price.setAttribute("data-add-price", add_price);
    calcCustomProductPrice();
  }
};
function calcAdditionalFeaturePrice(selected_value, feature_key, feature_field = 'drop-down', feature_handle = '') {
  let data_additional_feature = document.querySelector(`input[name="list-options_${feature_key}"]`);
  let list_options = window.custom_product.additional[feature_key.replace('additional_feature_', '')]?.options || [];
  let add_price = 0;
  let price_base = 0;
  let select_option = null;
  if (data_additional_feature) {

    data_additional_feature.closest('.wim-additional-feature').querySelector('.selected-option').textContent = selected_value;
    if (feature_handle && selected_value !== "" && ![null, "null"].includes(selected_value)) {

      select_option = list_options.find(item => item.handle === feature_handle);
    }
    else {

      select_option = list_options.find(item => Object.keys(item.name).some(key => item.name[key] === selected_value));
    }
    if (select_option) {
      let base_feature_prices = document.querySelectorAll('input[type="hidden"][data-type="base"]');
      if (select_option.type === 'percentage') {
        if (base_feature_prices) {
          price_base = Array.from(base_feature_prices).reduce((previous_item, current_item) => {
            previous_item += parseFloat(current_item.dataset.addPrice) || 0;
            return previous_item;
          }, 0);
        }
        price_base += (parseFloat(document.querySelector('[data-custom-product-price]').dataset.customProductPrice) / 100);
        add_price = price_base * (select_option.value / 100);
      }
      else {
        add_price = select_option.value;
      }
      data_additional_feature.setAttribute("data-propertie-value", selected_value);
      data_additional_feature.setAttribute("data-handle", select_option.handle);
    }
    else {
      data_additional_feature.setAttribute("data-propertie-value", "");
      data_additional_feature.setAttribute("data-handle", "");
    }
    data_additional_feature.setAttribute("data-add-price", add_price);
    calcCustomProductPrice();
  }
};
function calcCustomProductPrice() {

  let list_base_feature_prices = document.querySelectorAll('input[type="hidden"][data-type="base"]');
  let list_additional_feature_prices = document.querySelectorAll('input[type="hidden"][data-type="additional"]');
  let base_feature_price = 0;
  let additional_feature_price = 0;
  let count_features = 0;
  if (list_base_feature_prices) {
    base_feature_price = Array.from(list_base_feature_prices).reduce((previous_item, current_item) => {
      previous_item += parseFloat(current_item.dataset.addPrice) || 0;
      count_features += 1;
      return previous_item;
    }, 0);
  }
  if (list_additional_feature_prices) {
    let list_features = [];
    let feature_handles = [];
    let count_additional = 0;
    additional_feature_price = Array.from(list_additional_feature_prices).reduce((previous_item, current_item) => {
      previous_item += parseFloat(current_item.dataset.addPrice) || 0;
      count_features += 1;
      count_additional += 1;
      if (current_item.dataset.field != 'input-text') {
        if (current_item.dataset.propertieValue && current_item.dataset.propertieValue !== "") {
          list_features.push(`${current_item.dataset.propertieKey}: ${current_item.dataset.propertieValue}`);
          if (current_item.dataset.handle) {
            feature_handles.push(`${current_item.dataset.key.replace(/^additional_feature_/, '')}:${current_item.dataset.handle};`);
          }
        }
      }
      else if (current_item.dataset.field === 'input-text') {

        let input_fields = document.querySelectorAll(`input[type="text"][data-type="additional"][data-key="${current_item.dataset.key}"]`);
        if (input_fields) {
          let input_values = Array.from(input_fields).reduce((previous_value, current_value) => {
            if (current_value.value && !["", null, "null"].includes(current_value.value)) {
              previous_value.push(current_value.value);
              feature_handles.push(`${current_value.dataset.key.replace(/^additional_feature_/, '')}:${current_value.dataset.handle};`);
            }
            return previous_value;
          }, []);
          if (input_values.length > 0) {
            list_features.push(`${current_item.dataset.propertieKey}: ${input_values.join(' - ')}`);
          }
        }
      }
      return previous_item;
    }, 0);
    const characteristicsInput = document.querySelector('input[name="properties[Caracteristicas]"]');
    const featuresInput = document.querySelector('input[name="properties[_features]"]');
    if (characteristicsInput) {
      characteristicsInput.value = list_features.length == count_additional ? list_features.join(', ') : '';
    }
    if (featuresInput) {
      featuresInput.value = feature_handles.join('');
    }
  }
  let product_price = document.querySelector('[data-custom-product-price]');
  if (product_price) {
    const formatterCurrency = new Intl.NumberFormat(product_price.dataset.customProductLocale, { style: 'currency', currency: product_price.dataset.customProductCurrency, minimumFractionDigits: 2 });

    let amount_format = formatterCurrency.format(((parseFloat(product_price.dataset.customProductPrice) || 0) / 100) + base_feature_price + additional_feature_price);
    product_price.textContent = amount_format;
    // product_price.textContent = `${ product_price.dataset.customProductCurrencyCode }${ amount_format.replace(/[^\d.,-]/g, '').trim() }`;
    product_price.classList.remove('d-none');
  }
  let error_features = [];
  let count_base = Array.from(list_base_feature_prices).filter(item => !["", null, "null"].includes(item.dataset.propertieValue)).length;
  let count_additional = Array.from(list_additional_feature_prices).filter(item => {
    if (item.dataset.field === 'input-text') {
      return true;
    }
    else {
      if (["", null, "null"].includes(item.dataset.propertieValue) && window.custom_product.additional[item.dataset.key.replace('additional_feature_', '')]) {
        error_features.push(window.custom_product.additional[item.dataset.key.replace('additional_feature_', '')]?.title);
      }
      return !["", null, "null"].includes(item.dataset.propertieValue)
    }
  }).length;
  if (count_base + count_additional === count_features) {

    document.querySelectorAll('.hidden-buy-buttons').forEach((item) => {
      item.classList.add('disabled');
    });
  }
  else {
    document.querySelectorAll('.hidden-buy-buttons').forEach((item) => {
      item.classList.remove('disabled');
    });
  }
  document.querySelector('.wim-product-custom__error-message-features').classList.add('d-none');
  if (error_features.length > 0) {
    document.querySelector('.wim-product-custom__error-message-features .features-required-list').innerHTML = `${error_features.join(', ')}.`;
    document.querySelector('.wim-product-custom__error-message-features').classList.remove('d-none');
  }
};
document.addEventListener("DOMContentLoaded", () => {

  let additional_feature_drop_downs = document.querySelectorAll('select[data-type="additional"]');
  let additional_feature_swatchs = document.querySelectorAll('input[type="radio"][data-type="additional"]');
  let additional_feature_fields = document.querySelectorAll('input[type="text"][data-type="additional"]');
  if (additional_feature_drop_downs) {
    additional_feature_drop_downs.forEach((select) => {
      select.addEventListener('change', (event) => {
        let selected_option = select.options[select.selectedIndex];
        if (selected_option) {
          calcAdditionalFeaturePrice(selected_option.value, select.dataset.key, event.target.dataset.field, selected_option.dataset.handle);
        }
      });
    });
  }
  if (additional_feature_swatchs) {
    let swatchs_by_name = Array.from(additional_feature_swatchs).reduce((previous_item, current_item) => {
      if (!previous_item.includes(current_item.name)) {
        previous_item.push(current_item.name);
      }
      return previous_item;
    }, []);
    if (swatchs_by_name.length > 0) {
      swatchs_by_name.forEach((name) => {
        let swatchs = document.querySelectorAll(`input[type="radio"][data-type="additional"][name="${name}"]`);
        if (swatchs) {
          swatchs.forEach((swatch) => {
            swatch.addEventListener('change', (event) => {
              calcAdditionalFeaturePrice(event.target.value, event.target.dataset.key, event.target.dataset.field, event.target.dataset.handle);
            });
          });
        }
      });
    }
  }
  if (additional_feature_fields) {
    let fields_by_name = Array.from(additional_feature_fields).reduce((previous_item, current_item) => {
      if (!previous_item.includes(current_item.name)) {
        previous_item.push(current_item.name);
      }
      return previous_item;
    }, []);
    if (fields_by_name.length > 0) {
      fields_by_name.forEach((name) => {
        let fields = document.querySelectorAll(`input[type="text"][data-type="additional"][name="${name}"]`);
        if (fields) {
          fields.forEach((field) => {
            field.addEventListener('input', (event) => {
              event.target.value = event.target.value.replace(/[^a-zA-Z0-9 ]/g, '');
              calcAdditionalFeaturePrice(event.target.value, event.target.dataset.key, event.target.dataset.field, event.target.dataset.handle);
            });
            field.addEventListener('change', (event) => {
              event.target.value = event.target.value.replace(/[^a-zA-Z0-9 ]/g, '');
              calcAdditionalFeaturePrice(event.target.value, event.target.dataset.key, event.target.dataset.field, event.target.dataset.handle);
            });
            field.addEventListener('blur', (event) => {
              event.target.value = event.target.value.replace(/[^a-zA-Z0-9 ]/g, '');
              calcAdditionalFeaturePrice(event.target.value, event.target.dataset.key, event.target.dataset.field, event.target.dataset.handle);
            });

          });
        }
      });
    }
  }
  let mts_prev_add_to_cart = document.querySelector('.wim-prev-add-to-cart');
  if (mts_prev_add_to_cart) {
    mts_prev_add_to_cart.addEventListener('click', (event) => {

      let input_mts = document.querySelector('input[name="properties[Metros]"]');
      if (input_mts) {
        const stock_mts = parseFiniteNumber(input_mts.dataset.stockMts);
        if (stock_mts === null) {
          console.error('Cannot update Metros because stockMts is not a finite number.', input_mts.dataset.stockMts);
          return;
        }

        const formatted_stock_mts = stock_mts.toFixed(2);
        document.querySelector('.product__submit__item--error-message-stock-mts').classList.remove('d-none');
        input_mts.value = formatted_stock_mts;
        input_mts.setAttribute("data-propertie-tela-mts", formatted_stock_mts);
      }
      setTimeout(() => {
        mts_prev_add_to_cart.classList.add('d-none');
      }, 500);
    });
  }
});